import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as productActions from '../_actions/product';
import { Product } from '../_models';

export interface ProductState extends EntityState<Product> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>();

const initialState: ProductState = adapter.getInitialState({
  loading: false,
  error: null,
});

const productReducer = createReducer(
  initialState,

  on(productActions.loadProducts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(productActions.loadProductsSuccess, (state, { products }) =>
    adapter.setAll(products, { ...state, loading: false })
  ),

  on(productActions.loadProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(productActions.addProductSuccess, (state, { product }) => adapter.addOne(product, state)),

  on(productActions.updateProductSuccess, (state, { product }) =>
    adapter.upsertOne(product, state)
  ),

  on(productActions.deleteProductSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    productActions.addProductFailure,
    productActions.updateProductFailure,
    productActions.deleteProductFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: ProductState | undefined, action: Action) {
  return productReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
